






























































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Portfolio from "@/lib/models/Portfolio";
import User from "@/lib/models/User";
import BankAccount from "@/lib/models/BankAccount";
// @ts-ignore
import jsonCurrencies from "../../data/currencies.json";
import {defaultCurrency} from "@/lib/models/sumbols";

@Component({})
export default class EditModal extends Vue {
    private $firebase: any;

    @Prop() portfolio?: Portfolio;
    @Prop() user?: User;
    @Prop() accounts?: BankAccount[];
    @Prop() collection?: firebase.database.ThenableReference;

    @Watch('portfolio')
    onChildChanged(val: Portfolio, oldVal: Portfolio) {
        this.portfolioToEdit = (new Portfolio()).fromObject(val) as Portfolio;
        if (this.portfolioToEdit.idDefaultPaymentAccount && this.accounts && this.accounts.some(a => a.id === this.portfolioToEdit?.idDefaultPaymentAccount)) {
            // @ts-ignore
            this.selectedAccount = this.accounts.find(a => a.id === this.portfolioToEdit?.idDefaultPaymentAccount);
        }
        if (this.portfolioToEdit.currency === null && this.user) {
            this.portfolioToEdit.currency = this.user.currency;
        } else if (this.portfolioToEdit.currency === null) {
            this.portfolioToEdit.currency = defaultCurrency;
        }

    }

    portfolioToEdit: Portfolio | null = null;
    selectedAccount: BankAccount | null = null;
    isOpen: boolean = false;

    toggle() {
        this.isOpen = !this.isOpen
    }

    get currencies(): Array<{ [k: string]: string | number }> {
        return Object.keys(jsonCurrencies).map((key: string) => {
            // @ts-ignore
            return jsonCurrencies[key] as { [k: string]: string | number };
        }) as Array<{ [k: string]: string | number }>;
    }

    submitForm() {
        if (this.$refs.submitButton) {
            (this.$refs.submitButton as HTMLButtonElement).click();
        }
    }

    removePortfolio() {
        this.$swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value && this.user && this.portfolioToEdit) {

                this.$firebase.database().ref(`portfolio/${this.user.uid}/${this.portfolioToEdit.id}`).remove((err: Error | null) => {
                    if (err === null) {
                        this.toggle();
                        this.$swal(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                    } else {
                        this.$swal(
                            'Error!',
                            'Unable to delete: ' + err.message,
                            'error'
                        )
                    }
                });

            }
        });
    }

    savePortfolio() {

        if (this.portfolioToEdit && this.user && this.portfolio) {
            const updates: { [k: string]: any } = {};

            if (this.selectedAccount) {
                this.portfolioToEdit.idDefaultPaymentAccount = this.selectedAccount.id;
            } else {
                this.portfolioToEdit.idDefaultPaymentAccount = null;
            }
            const editValue = Object.assign({}, this.portfolioToEdit) as { [k: string]: any };
            delete editValue['_moves'];
            delete editValue['_priceUpdates'];

            Object.keys(editValue).forEach((key) => {
                // @ts-ignore
                updates[`portfolio/${this.user.uid}/${this.portfolio.id}/${key}`] = editValue[key];
            });

            this.$firebase.database().ref().update(updates).then((res: any) => {
                console.log(res);
            }).catch((e: Error) => {
                console.log(e);
            }).finally(() => {
                this.toggle();
            });

        }
    }
}
